import { LayoutModule } from '@angular/cdk/layout';
import { APP_BASE_HREF } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DoBootstrap, Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtModule } from '@auth0/angular-jwt';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HotkeyModule } from 'angular2-hotkeys';
import { ToastrModule } from 'ngx-toastr';
import { ErrorInterceptor } from '../shared/interceptors/error.interceptor';
import { RobotsRootComponent } from './components/robots-root/robots-root.component';
import { RobotsSharedModule } from './robots-shared.module';
@NgModule({
  declarations: [
    RobotsRootComponent,
  ],
  imports: [
    RobotsSharedModule,
    LayoutModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgbModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          const info = localStorage.getItem('token');
          return info ? JSON.parse(localStorage.getItem('token')).access_token : null;
        },
        skipWhenExpired: false,
        allowedDomains: [
          'localhost:59944',
          'localhost:56344',
          'localhost:7071',
          'api-contador.nibo.com.br',
          'api-iu-contador.nibo.com.br',
          'brnibo.blob.core.windows.net',
          'arquivos.nibo.com.br',
          'passport.nibo.com.br',
          'test-files.nibo.com.br',
          'test-api-contador.nibo.com.br',
        ],
        disallowedRoutes: [/test-files.nibo.com.br\/download\/.*/, /arquivos.nibo.com.br\/download\/.*/],
      },
    }),
    ToastrModule.forRoot({
      enableHtml: true,
    }),
    HotkeyModule.forRoot({
      cheatSheetCloseEsc: true,
    }),
  ],
  exports: [],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: APP_BASE_HREF, useValue: '/' },
  ],
  entryComponents: [RobotsRootComponent],
})
export class RobotsWebComponentModule implements DoBootstrap {
  constructor(private _injector: Injector) {}

  ngDoBootstrap(): void {
    if (!customElements.get('robot-creation')) {
      customElements.define('robot-creation', createCustomElement(RobotsRootComponent, { injector: this._injector }));
    }
  }
}
